<template>
  <div>
    <SnackbarComponent v-model="snackbar.show" :message="snackbar.message" :color="snackbar.color" />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h6 pa-4">Confirm Delete Case</v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <div class="text-body-1">
            Are you sure you want to delete
            <strong>{{ ticket?.caseId || ticket?.ticketId }}</strong>?
          </div>
          <div class="text-caption text-medium-emphasis mt-2">
            This action cannot be undone.
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose" :disabled="loading">
            Cancel
          </v-btn>
          <v-btn color="error" variant="flat" :loading="loading" @click="handleDelete">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SnackbarComponent from "@/components/Extras/Snackbar.vue";
import { edit_ticket } from "@/graphql/mutations";
import { generateClient } from "aws-amplify/api";

export default {
  name: "DeleteTicket",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    ticket: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue", "deleted"],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
    },
    async handleDelete() {
      if (!this.ticket?.ticketId && !this.ticket?.ticket_id) return;

      this.loading = true;

      try {
        const input = {
          ticket_id: this.ticket.ticketId || this.ticket.ticket_id,
          ticket_status: "DEACTIVE",
        };

        const client = generateClient();
        const response = await client.graphql({
          query: edit_ticket,
          variables: {
            input,
          },
        });

        let responseData = response.data.edit_ticket;
        if (typeof responseData === "string") {
          responseData = JSON.parse(responseData);
        }

        if (responseData.status != "SUCCESS") {
          throw new Error(responseData.status_message || "Failed to delete case");
        }

        this.snackbar = {
          show: true,
          message: "Case deleted successfully!",
          top: true,
          color: "success",
        };

        this.$emit("deleted", this.ticket);
        this.dialog = false;
      } catch (error) {
        this.snackbar = {
          show: true,
          message: error?.message || "Failed to delete case",
          top: true,
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>
